import CollectNotification from './CollectNotification';
import CollectNotificationContainer from './CollectNotification.container';
export default CollectNotificationContainer(CollectNotification);
export { SCROLL_TO_FOLDER_HASH_SIGNAL } from './CollectNotification';
//# sourceMappingURL=index.js.map